<template>
  <div class="input-inheritance-toggle uk-margin">
    <div>
      <div
        v-if="isOverridden"
        class="input-inheritance-toggle__container input-inheritance-toggle__container--overridden"
      >
        <slot />
      </div>
      <form-group v-else :label="label">
        <div class="input-inheritance-toggle__container input-inheritance-toggle__container--inherited">
          <slot name="inherited">{{value}}</slot>
        </div>
      </form-group>
    </div>

    <div class="input-inheritance-toggle__checkbox-container">
      <label>
        <input
          type="checkbox"
          class="uk-checkbox"
          v-model="isOverridden"
          @input="onInput"
        />
        {{toggleLabel}}
      </label>
    </div>
  </div>
</template>

<script>
import Checkbox from '@/components/Checkbox';
import FormGroup from '@/components/FormGroup';
import InheritanceToggle from '@/mixins/InheritanceToggle';

export default {
  name: 'input-inheritance-toggle',
  mixins: [InheritanceToggle],
  components: {
    Checkbox,
    FormGroup,
  },
  props: {
    label: [Boolean, String],
  },
};
</script>

<style lang="scss">
.input-inheritance-toggle {
  &__checkbox-container {
    margin-top: -12px;
    font-size: 0.875rem;
  }

  &__container--inherited {
    opacity: 0.6;
  }
}
</style>



// WEBPACK FOOTER //
// InputInheritanceToggle.vue?834eeeac